import { Thunk } from '../../types/reduxTypes';
import { getCollapsedCommentPopupId } from '../../../common/elements/utils/collapsedCommentPopupUtils';
import { closePopup, openPopup } from '../../components/popupPanel/popupActions';
import popupOpenSelector from '../../components/popupPanel/popupOpenSelector';
import { removeSelectedElements, setSelectedElements } from '../selection/selectionActions';

/**
 * Closes other popups when opening the inline comment popup & ensures the comment thread
 * gets selected or deselected appropriately.
 */
export const toggleInlineCommentPopup =
    (commentThreadId: string, isEditable?: boolean): Thunk =>
    (dispatch, getState) => {
        const state = getState();

        const popupId = getCollapsedCommentPopupId(commentThreadId);

        const isPopupOpen = popupOpenSelector(popupId)(state);

        // Close all popups, in case another popup is open - we need to do this
        //  because the CommentThreadCollapsedPopup's PopupPanelMouseManager ignores
        //  clicks on other inline-comments
        dispatch(closePopup('', true));

        if (isPopupOpen) {
            return dispatch(removeSelectedElements({ ids: [commentThreadId], transactionId: undefined }));
        }

        dispatch(openPopup({ popupId }));

        if (isEditable) {
            dispatch(
                setSelectedElements({ ids: [commentThreadId], transactionId: undefined, rangeAnchors: undefined }),
            );
        }
    };
